<script>
  import Card from '@components/live_sessions/card.svelte'
  import Empty from '@components/general/empty.svelte'
  let { live_sessions = [] } = $props()
</script>

<div class="grid gap-10 grid-cols-[repeat(auto-fill,minmax(25rem,1fr))]">
  {#each live_sessions as live_session (live_session.id)}
    
    <!-- The live session card -->
    <Card session={live_session} />
  {:else}
    <Empty message="No live sessions found" />
  {/each}
</div>
